























import { Component, Inject, Prop, Vue, } from 'vue-property-decorator';
import { Headquarter, HeadquarterTemplate } from '@/data/models/headquarter.model';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';

import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

@Component({
	components: {
		quillEditor
	}
})
export default class HeadquarterTemplateData extends Vue {
	@Prop() headquarter!: Headquarter;
	@Prop() editable!: boolean;

	@Inject('CrudService') headquartertemplateCrudService!: CrudService<HeadquarterTemplate>;

	newTemplate!: HeadquarterTemplate;

	editorOption = {
		modules: {
			toolbar: [
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				['bold', 'italic', 'underline'],
			]
		}
	}
	
	constructor() {
		super();
		this.newTemplate = new HeadquarterTemplate();
	}

	load() {
		const search = new Search('headquartertemplate');
		search.addSimpleFilter('hid', this.headquarter.id);
		this.headquartertemplateCrudService
			.searchEntities(HeadquarterTemplate, 'headquartertemplate', search, new Page(1))
			.then((results: HeadquarterTemplate[]) => {
				if (results.length) {
					this.newTemplate = results[0];
				}
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	submit() {
		this.newTemplate.hid = this.headquarter.id;

		this.headquartertemplateCrudService
			.createEntity(HeadquarterTemplate, 'headquartertemplate', this.newTemplate)
			.then((template: HeadquarterTemplate) => {
				this.newTemplate = template;
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	beforeMount() {
		this.load();
	}

}
